import Vue from 'vue';
import Vuex from 'vuex';
import { firebaseMutations } from 'vuexfire';
import Auth from '@/store/modules/auth';
import Admin from '@/store/modules/admin';
import Transcription from './modules/transcription';
import Dialog from './modules/dialog';
import Snackbar from './modules/snackbar';
import Notifications from './modules/notifications';

Vue.use(Vuex);

export default new Vuex.Store({
  mutations: { ...firebaseMutations },
  modules: {
    auth: Auth,
    admin: Admin,
    transcription: Transcription,
    dialog: Dialog,
    snackbar: Snackbar,
    notifications: Notifications,
  },
  getters: {},
});
